// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","menu__item":"Menu_menu__item__+bZF5","menu__icon":"Menu_menu__icon__wB-S5","menu__text":"Menu_menu__text__cpZMw"};